<template>
  <div>
    <div class="mb-3">
      <div class="col-md-12">
        <label class="form-col-label control-label">{{
            $t('newsCategory.newsCategoryName')
        }}</label>
        <input v-model.trim="model.category_name" type="text" class="form-control" :class="{
          'is-invalid': errors.has('category_name')
        }" ref="category_name" />
      </div>
    </div>
    <div slot="footer">
      <div class="ts-flex ts-justify-end ts-space-x-2 ts-sh mr-3">
        <ts-button @click.prevent="() => $emit('cancel')" class="btn-gray">
          {{ $t('cancel') }}</ts-button>
        <ts-button v-if="!isUpdate" color="primary" outline :waiting="waitingSaveNew""
          @click.prevent="onSaveAddNew">
          {{ $t('save_add_new') }}</ts-button>
        <ts-button color="primary" v-if="!isUpdate"  :waiting="waitingSave"  @click.prevent="onSave">
          {{ $t('save') }}</ts-button>
        <ts-button v-if="isUpdate" color="primary" @click.prevent="onUpdate" :waiting="waiting">
          {{ $t('update') }}</ts-button>
      </div>
    </div>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState, mapActions } from 'vuex'
import { isEmpty, includes } from 'lodash'

// iview
//import 'view-design/dist/styles/iview.css'
import Vue from 'vue'
import ViewUI from 'view-design'
import locale from 'view-design/dist/locale/en-US'
Vue.use(ViewUI, { locale })
Vue.use(ViewUI)

export default {
  name: 'news-categoryForm',
  data() {
    return {
      errors: new Errors(),
      loading: false,
      waiting: false,
      waitingSave: false,
      waitingSaveNew: false,
      model: {
        category_name: null,
      }
    }
  },
  computed: {
     ...mapState('website/newsCategory', [
      'edit_data',
    ]),
    isUpdate() {
      return !isEmpty(this.edit_data)
    },
  },
  created() {
    this.setEditData();
  },
  methods: {
    ...mapActions('website/newsCategory', [
      'getCategoryName',
    ]),
    async onSaveAddNew() {
      this.errors = new Errors()
       this.waitingSaveNew = true
      this.$store
        .dispatch('website/newsCategory/store', this.model)
        .then(response => {
          this.waitingSaveNew = false
          this.notice({
            type: response.message_id == 0 ? 'success' : 'warning',
            text: response.message
          })
          this.$emit('fetchData')
          this.clearInput()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.notice({ type: 'error', text: error.message })
           this.waitingSaveNew = false
        })
    },
    async onSave() {
      this.errors = new Errors()
      this.waitingSave = true
      this.$store
        .dispatch('website/newsCategory/store', this.model)
        .then(response => {
          this.waitingSave = false
          this.notice({
            type: response.message_id == 0 ? 'success' : 'warning',
            text: response.message
          })
          this.$emit('cancel')
          this.$emit('fetchData')
        })
        .catch(error => {
          this.waitingSave = false
          this.errors = new Errors(error.errors)
          this.notice({ type: 'error', text: error.message })
        })
    },
     onUpdate() {
      this.waiting = true
      this.$store
        .dispatch('website/newsCategory/update', {
          id: this.edit_data.news_category_id,
          data: this.model
        })
        .then(response => {
          this.notice({
            type: response.message_id == 0 ? 'success' : 'warning',
            text: response.message
          })
          this.$emit('cancel')
          this.$emit('fetchData')
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.notice({ type: 'error', text: error.message })
          this.waiting = false
        })
    },
  
    setEditData() {
      this.$nextTick(function () {
        this.$refs.category_name.focus()
      })
      if (!isEmpty(this.edit_data)) {
        this.model.category_name = this.edit_data.category_name
      }
    },
    clearInput() {
      this.errors = new Errors()
      this.model.category_name = null;
    },
    notice(not) {
      this.$Notice[not.type]({
        title: 'NEWS CATEGORY',
        desc: not.text
      })
    }
  }
}
</script>
